<ng-container>
	<base-display #display [alignment]="'right'" [smallLetters]="s()" [bigLetters]="b()" [unit]="''"></base-display>
</ng-container>
